import { NavItemsService } from '@abp/ng.theme.shared';
import { eThemeBasicComponents } from '@abp/ng.theme.basic';
import { APP_INITIALIZER } from '@angular/core';
import { take } from 'rxjs/operators';
import { CurrentUserComponent } from '../components/nav-items/current-user.component';
import { FullScreenComponent } from '../components/nav-items/full-screen.component';
import { LanguagesComponent } from '../components/nav-items/languages.component';
import { eThemeMetronicComponents } from '../enums/components';

export const METRONIC_THEME_NAV_ITEM_PROVIDERS = [
	{
		provide: APP_INITIALIZER,
		useFactory: configureNavItems,
		deps: [NavItemsService],
		multi: true,
	},
];

export function configureNavItems(navItems: NavItemsService) {
	return () => {
		navItems.removeItem(eThemeMetronicComponents.Languages)
		navItems.removeItem(eThemeMetronicComponents.CurrentUser)
		navItems.addItems([
			{
				id: eThemeMetronicComponents.Languages,
				order: 100,
				component: LanguagesComponent,
			},
			{
				id: eThemeMetronicComponents.CurrentUser,
				order: 100,
				component: CurrentUserComponent,
			},
			{
				id: eThemeMetronicComponents.FullScreen,
				order: 100,
				component: FullScreenComponent,
			},
		]);
	};
}
